import React from "react";
import { $t } from '@/modules/i18n';

export default ({ message }) => message ? (
  <section id="finalists">
    <h2 className="section-title">{$t(message.title)}</h2>
    { message.desc.map(item => <p key={item} className="desc">{$t(item)}</p>) }
    <a className="sigh-up" href={message.link} target="_blank" rel="noopener noreferrer">{$t(message.btn)}</a>
  </section>
) : null;
